import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { numberWithCurrency } from '@hivebrite/utils';
import { __ } from '@design-system/i18n';
import { Flag } from './Flag';
export const FlagPricing = (_a) => {
    var { currency = {
        code: 'USD',
    }, max = 0, maxWidth, min = 0, text } = _a, otherProps = __rest(_a, ["currency", "max", "maxWidth", "min", "text"]);
    const options = {
        currencyDisplay: 'symbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    };
    let label = text;
    if (!label) {
        if (min === 0 && max === 0) {
            label = __('Free');
        }
        else if (min === max) {
            label = numberWithCurrency({ currency, options, value: min });
        }
        else {
            label = `${numberWithCurrency({
                currency,
                options,
                value: min,
            })} - ${numberWithCurrency({ currency, options, value: max })}`;
        }
    }
    return _jsx(Flag, Object.assign({ maxWidth: maxWidth, text: label }, otherProps));
};
//# sourceMappingURL=FlagPricing.js.map